<div
  id="alert-grouped"
  [@inOutAnimation]
  class="alert alert-dismissible alert-danger"
  role="alert"
  *ngIf="messageGroup"
  (window:keydown)="keyboardEvent($event)"
>
  <div class="row gutter-sm">
    <div class="col-auto d-flex align-items-center">
      <span class="fal fa-exclamation-circle fa-xxl"></span>
    </div>

    <div class="col">
      <p>{{ "common.errors.info" | translate }}</p>
      <ul class="mb-0 pl-4">
        <li *ngFor="let message of messageGroup">
          {{ message }}
        </li>
      </ul>
    </div>
  </div>

  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div
  *ngIf="message"
  id="alert-msg"
  [@inOutAnimation]
  [ngClass]="{
    alert: message,
    'alert-success': message.type === 'success',
    'alert-danger alert-version-update': message.type === 'versionUpdate',
    'alert-danger': message.type === 'error',
    'alert-warning': message.type === 'warning'
  }"
  class="alert-dismissible"
  role="alert"
  (window:keydown)="keyboardEvent($event)"
>
  <div class="row gutter-sm">
    <div class="col-auto d-flex align-items-center">
      <span
        class="fal fa-exclamation-circle fa-xxl"
        *ngIf="message.type === 'error'"
      ></span>
      <span
        class="fal fa-check-circle fa-xxl"
        *ngIf="message.type === 'success'"
      ></span>
    </div>
    <div class="col">
      <p class="mb-1" *ngIf="multipleMessages(message.text)">
        {{ "common.errors.multiple_errors" | translate }}:
      </p>
      <p class="mb-0" [ngClass]="{ small: multipleMessages(message.text) }">
        {{ message.text }}
      </p>
    </div>

    <div class="col-5" *ngIf="message.type === 'versionUpdate'">
      <kupari-button
        [class]="'btn btn-primary'"
        [text]="'updates.update_now'"
        [confirmText]="'updates.update_confirmation'" [confirm]="true"
        [confirmTextPosition]="'below'"
        (onClick)="updateService.applyUpdateAndReloadAllTabs()"
      ></kupari-button>
    </div>
  </div>

  <button
    type="button"
    *ngIf="message.type !== 'versionUpdate'"
    class="close"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>

  <div
    class="progress"
    *ngIf="message?.closeAutomatically && message?.showProgressBar"
    [ngClass]="{
      success: message.type === 'success',
      error: message.type === 'error',
      warning: message.type === 'warning'
    }"
  >
    <mat-progress-bar
      mode="determinate"
      [value]="progressValue"
    ></mat-progress-bar>
  </div>
</div>
